export const COLOR_PRIMARY = "#007bff"
export const COLOR_SELECTED = "#e7f1fa"
export const COLOR_DEFAULT = "#f4f4f4"
